module.exports = __webpack_public_path__ + "default-card-image-31d7699de5f98c1d195b.svg";